import { createSelector } from '@reduxjs/toolkit';
import { selectObjectTypeOptions } from './selectObjectTypeOptions';
import { selectDealType, selectJsonQuery } from 'shared/selectors/jsonQuery';
import { FDealType, isAvailable, isAvailableStrict } from '../../../../packages/JsonQuery';

export const selectObjectTypeValue = createSelector(
  [selectObjectTypeOptions, selectDealType, selectJsonQuery],
  (objectTypeOptions, currentDealType, jsonQuery) => {
    const availability = currentDealType === FDealType.Sale ? isAvailableStrict : isAvailable;

    return objectTypeOptions
      .map(objectType => objectType.value)
      .filter(objectType => availability(currentDealType, objectType)(jsonQuery));
  },
);
